export const BR = {
  Seja_bem_vindo_ao_nosso_portal: "Seja bem vindo ao nosso portal",
  Cooperado: "Cooperado",
  Faca_seu_login: "Faça seu login",
  Esqueci_minha_senha: "Esqueci minha senha",
  Usuario: "Usuário",
  Entrar: "Entrar",
  Esqueceu_a_senha: "Esqueceu a senha?",
  Vamos_enviar_a_recuperação_de_senha_para_seu_email_cadastrado_tudo_bem:
    "Vamos enviar a recuperação de senha para seu e-mail cadastrado, tudo bem?",
  Caso_voce_nao_possua_mais_acesso_ao_email_vinculado_a_sua_conta_entre_em_contato_com_o_suporte:
    "Caso você não possua mais acesso ao e-mail vinculado à sua conta, entre em contato com o suporte.",
  Enviar: "Enviar",
  Recuperar_senha: "Recuperar senha",
  Digite_o_email_associado_a_sua_conta: "Digite o e-mail associado à sua conta",
  E_mail: "E-mail",
  Continental_2025___Todos_os_direitos_reservados:
    "Continental 2025 - Todos os direitos reservados",
  Confirmacao: "Confirmação",
  Vamos_enviar_a_recupera_o_de_senha_para_seu_e_mail_tudo_bem:
    "Vamos enviar a recuperação de senha para seu e-mail, tudo bem?",
  Confirme_abaixo_o_e_mail_cadastrado: "Confirme abaixo o e-mail cadastrado",
  E_mail_invalido: "E-mail inválido",
  Alterar_a_sua_senha: "Alterar a sua senha",
  Vamos_cadastrar_sua_senha: "Vamos cadastrar sua senha",
  Usuario_invalido: "Usuário inválido",
  Codigo_invalido: "Código inválido",
  Confirmar_senha: "Confirmar senha",
  Forca_da_sua_senha: "Força da sua senha",
  Conter_no_m_nimo_8_caracteres: "Conter no mínimo 8 caracteres",
  Conter_numeros: "Conter números",
  Conter_letras_maiusculas_e_minusculas:
    "Conter letras maiúsculas e minúsculas",
  Conter_caracteres_especiais: "Conter caracteres especiais",
  Confirmacao_de_senha_igual: "Confirmação de senha igual",
  Fraca: "Fraca",
  Media: "Média",
  Forte: "Forte",
  Inicio: "Inicio",
  Processos: "Processos",
  Aprovacao_de_verba: "Aprovacao de verba",
  Comprovacao: "Comprovacao",
  Financeiro: "Financeiro",
  Midia_center: "Media Library",
  Galeria_de_midia: "Media Library",
  Editor_de_templates: "Editor de templates",
  Cadastros: "Cadastros",
  Gestao_de_processos: "Gestão de processos",
  Política_de_accrual: "Política de accrual",
  Banners: "Banners",
  Banner: "Banner",
  Noticias: "Notícias",
  Notificacoes: "Notificações",
  Prazos: "Prazos",
  Relatorios: "Relatórios",
  Fale_conosco: "Fale conosco",
  Portal: "Portal",
  Meu_cadastro: "Meu cadastro",
  Ausencia_temporaria: "Ausência temporaria",
  Sair: "Sair",
  Ola: "Olá",
  Bem_vindo_ao_portal_do_administrador:
    "Bem-vindo (a) ao portal do administrador",
  Voce_possui: "Você possui",
  Mensagens_nao_lidas: "Mensagens não lidas",
  Consulta: "Consulta",
  Rapida: "Rápida",
  Buscar: "Buscar",
  Resultados: "Resultados",
  Ano: "Ano",
  Mes: "Mês",
  Revenda: "Revenda",
  Status: "Status",
  Faca_sua_pesquisa: "Faça sua pesquisa",
  Digite_aqui_para_pesquisar: "Digite aqui para pesquisar",
  Numero_solicitacao: "Nº Solicitação",
  Data_hora_de_criacao: "Data/Hora de criação",
  Acao: "Ação",
  Campanha: "Campanha",
  Visualizar: "Visualizar",
  Editar: "Editar",
  Excluir: "Excluir",
  Detalhes: "Detalhes",
  Fechar: "Fechar",
  Ultimas_noticias: "ÚLTIMAS NOTÍCIAS",
  Saiba_mais: "SAIBA MAIS",
  Voltar: "Voltar",
  Aprovacao_de_Verba: "Aprovação de Verba",
  Verba: "Verba",
  Area_para_acompanhamento_das_comprovacoes:
    "Área para acompanhamento das comprovações",
  Area_para_acompanhamento_das_solicitacoes_de_verba:
    "Área para acompanhamento das solicitações de verba",
  Selecione: "Selecione",
  Solicitacao_de_Verba: "Solicitação de Verba",
  Grupo: "Grupo",
  Grupos: "Grupos",
  Regiao: "Região",
  Segmento: "Segmento",
  Revenda: "Revenda",
  Status: "Status",
  Minhas_pendencias: "Minhas pendências",
  Em_andamento: "Em andamento",
  Reiniciadas: "Reiniciadas",
  Aprovadas: "Aprovadas",
  Reprovadas: "Reprovadas",
  Finalizadas: "Finalizadas",
  As_solicitacoes_abaixo_aguardam_uma_acao_sua:
    "As solicitações abaixo aguardam uma ação sua",
  Data_de_Inicio: "Data de Início",
  Tipo_de_Acao: "Tipo de Ação",
  Valor_Estimado: "Valor Estimado",
  Valor_Reembolso: "Valor Reembolso",
  Aprovar_selecionados: "Aprovar selecionados",
  Transferir_Verba: "Transferir Verba",
  Transferencia_de_Verba: "Transferência de Verba",
  Tipo_de_Transferencia: "Tipo de transferência",
  Tipo_de_prazo: "Tipo de prazo",
  Selecione_tipo_de_prazo: "Selecione tipo de prazo",
  Inserir_data: "Inserir data",
  Fim: "Fim",
  Siga_nossas_redes_sociais: "Siga nossas redes sociais",
  Atencao_Percentual_de_Reembolso:
    "Atenção! Percentual de reembolso informado manualmente pela Revenda. Não segue a Política de Accrual vigente para o período",
  Documentos: "Documentos",
  Data_e_Hora_de_criacao: "Data e Hora de criação",
  Ano_da_competencia: "Ano da competência",
  Mes_da_competencia: "Mês da competência",
  ProcessoN: "Processo Nº",
  Dados_do: "Dados do",
  Dados_da: "Dados da",
  Solicitante: "Solicitante",
  Etapas_do: "Etapas do",
  Processo: "Processo",
  CnpjCuit: "CNPJ/CUIT",
  Razao_Social: "Razão social",
  Responsavel_loja: "Responsável da loja (Nome)",
  Responsavel_Continental: "Responsável Continental",
  Canal_de_venda: "Canal de venda",
  Categoria_de_reembolso: "Categoria de reembolso",
  Tipo_de_reembolso: "Tipo de reembolso",
  Valor_previsto_para_reembolso: "Valor previsto para reembolso",
  Porcentagem_de_reembolso: "Porcentagem de reembolso(%)",
  Informar_percentual_manualmente: "Informar percentual manualmente",
  Uf: "UF",
  Cidade_de_vigencia: "Cidade de vigência",
  Descricao_da_acao: "Descrição da ação",
  Sim: "Sim",
  Nao: "Não",
  Justificativa: "Justificativa",
  Aprovacao_de: "Aprovação de",
  Documentacao_solicitada: "Documentação solicitada",
  Arquivo_solicitado: "Arquivo solicitado",
  Baixar: "Baixar",
  Retornar_verba: "Retornar verba",
  Aprovar: "Aprovar",
  Reprovar: "Reprovar",
  Historico: "Histórico",
  Data_Hora: "Data/Hora",
  Observacao: "Observação",
  Resetar_Verba: "Resetar Verba",
  Selecione_para_quem_deseja_retornar_a_verba:
    "Selecione para quem deseja retornar a verba",
  Usuarios_cadastrados: "Usuários cadastrados",
  Resetar: "Resetar",
  Anexar_arquivo: "Anexar arquivo",
  Reprovacao: "Reprovação",
  Confirmar: "Confirmar",
  Modulo_para_gestao_de_credito_de_reembolso:
    "Módulo para gestão dos créditos de reembolso",
  Importar_pagamentos: "Importar pagamentos",
  Total_solicitado: "Total solicitado",
  Total_aprovado_para_execucao: "Total aprovado para execução",
  Total_executado: "Total executado",
  Total_creditado: "Total creditado",
  Total_pendente: "Total pendente",
  Valores_finais_de_reembolso: "(*) Valores finais de reembolso",
  Cadastro: "Cadastro",
  Gerencie_usuarios_vendas_e_configuracoes_gerais_do_portal:
    "Gerencie usuários, vendas e configurações gerais do portal",
  Revendas: "Revendas",
  Usuarios: "Usuários",
  Configuracoes: "Configurações",
  Cadastrar_novo_usuario: "Cadastrar novo usuário",
  Importar_base_de_usuarios: "Importar base de usuários",
  Nome_ou_Login: "Nome ou Login",
  Perfil_de_acesso: "Perfil de acesso",
  Cadastrar_nova_revenda: "Cadastrar nova revenda",
  Importar_base_de_revendas: "Importar base de revendas",
  Importar_Mystery_Shopper: "Importar Mystery Shopper",
  Codigo_CNPJ_ou_Razao_Social: "Código, CNPJ ou Razão Social",
  Cnpj: "CNPJ",
  Classificacao_atual_Mystery_Shopper: "Classific. atual Mystery Shopper",
  Nome: "Nome",
  Login: "Login",
  Configuracao: "Configuração",
  Dados_Pessoais: "Dados Pessoais",
  Nome_obrigatorio: "Nome obrigatório",
  Email: "E-mail",
  Email_invalido: "E-mail inválido",
  Login_invalido: "Login inválido",
  Perfil_de_acesso_invalido: "Perfil de acesso inválido",
  Departamento_invalido: "Departamento inválido",
  Cargo_invalido: "Cargo inválido",
  Senha: "Senha",
  Senha_invalido: "Senha inválida",
  Cargo: "Cargo",
  Telefone: "Telefone",
  Departamento: "Departamento",
  Ativo: "Ativo",
  Inativo: "Inativo",
  Salvar: "Salvar",
  Dados_da_Revenda: "Dados da Revenda",
  Cnpj_obrigatorio: "CNPJ/CUIT obrigatório",
  Codigo_SAP_invalido: "Código SAP inválido",
  Codigo_Sap: "Código SAP",
  Razao_Social_invalida: "Razão Social inválida",
  Nome_Fantasia: "Nome Fantasia",
  Nome_Fantasia_invalido: "Nome Fantasia inválido",
  Departamentos: "Departamentos",
  Cargos: "Cargos",
  Canais_de_Venda: "Canais de Venda",
  Segmentos: "Segmentos",
  Campanhas: "Campanhas",
  Tipos_de_Acao: "Tipos de Ação",
  Regioes: "Regiões",
  Adicionar_perfil_de_acesso: "Adicionar perfil de acesso",
  Adicionar_tipo_de_acao: "Adicionar tipo de ação",
  Adicionar: "Adicionar",
  Data_hora_de_alteracao: "Data/hora de alteração",
  Total_de_cadastros: "Total de cadastros",
  DescricaoToolTips: "Descrição (tooltips)",
  Total_de_processos: "Total de processos",
  Ativar: "Ativar",
  Inativar: "Inativar",
  Perfil_de_acesso_obrigatorio: "Perfil de acesso obrigatório",
  Defina_os_parametros_da_configuracao_selecionada:
    "Defina os parâmetros da configuração selecionada.",
  Home: "Home",
  Aprovacao_de_verba: "Aprovação de verba",
  Editor_de_templates: "Editor de templates",
  Admin: "Admin",
  Acessa_portal: "Acessa portal",
  Acessa_admin: "Acessa admin",
  Canceladas: "Canceladas",
  Pagina: "Página",
  Todos: "Todos",
  Criar: "Criar",
  Politica_de_accrual: "Política de accrual",
  Faca_aqui_a_gestao_das_politicas_de_accrual:
    "Faça aqui a gestão das políticas de Accrual",
  Configuracao_de_: "Configuração de",
  Reembolso: "reembolso",
  Adicionar_nivel_de_classificacao: "Adicionar nivel de classificação",
  Semestre: "Semestre",
  Vigencia_da: "Vigência da",
  Politica: "Política",
  Data_inicial_da_vigencia: "Data inicial da vigência",
  Data_final_da_vigencia: "Data final da vigência",
  Nivel: "Nível",
  Categoria_de_Reembolso: "Categoria de Reembolso",
  Gestao_de_Banners: "Gestão de Banners",
  Gerencie_os_banners_que_serao_exibidos_na_pagina_inicial:
    "Gerencie os banners que serão exibidos na página inicial",
  Novo_Banner: "Novo Banner",
  Data_de_Termino: "Data de Termino",
  Indeterminado: "Indeterminado",
  Inserir_nome: "Inserir nome",
  Selecionar_tipo_de_prazo: "Selecionar tipo de prazo",
  Excluir_arte_do_banner: "Excluir arte do banner",
  Importar_arte_do_banner: "Importar arte do banner",
  Formatos_aceitos_jpeg_jpg_png: "Formatos aceitos: jpeg, jpg, png",
  Tamanho_recomendado_1920px_x_500px:
    "O tamanho recomendado para banners é de 1920px x 500px",
  Alterar: "Alterar",
  Gestao_de_Noticias: "Gestão de Notícias",
  Gerencie_as_noticias_que_serão_exibidas_na_pagina_inicial:
    "Gerencie as notícias que serão exibidas na página inicial",
  Nova_Noticia: "Nova Notícia",
  Tisub_tulo: "Titúlo",
  Descricao: "Descrição",
  Excluir_arte_da_noticia: "Excluir arte da notícia (CAPA)",
  Importar_arte_da_noticia: "Importar arte da notícia (CAPA)",
  Excluir_arte_da_noticia_principal: "Excluir arte da notícia (PRINCIPAL)",
  Importar_arte_da_noticia_principal: "Importar arte da notícia (PRINCIPAL)",
  Gestao_de_Notificacoes: "Gestão de Notificações",
  Envie_mensagens_para_os_usuarios: "Envie mensagens para os usuários",
  Enviar_nova_notificacao: "Enviar uma nova notificação",
  Destinatarios: "Destinatários",
  Configuracao_de_prazos_Revendas: "Configuração de prazos (Revendas)",
  Defina_aqui_os_prazos_para_inclusao_de_verba_e_comprovacao:
    "Defina aqui os prazos para inclusão de verba e comprovação",
  Selecione_o: "Selecione o",
  Informe_a: "informe a",
  Data_limite: "Data limite",
  Alterar_Todos: "Alterar todos",
  E_Em_Seguida: "e em seguida",
  Nova_Data: "Nova data",
  Relatorios: "Relatórios",
  Escolha_Um: "Escolha um",
  Tipo_de_Relatorio: "Tipo de relatório",
  E_na_sequencia_preencha_todos_os_campos_para_exportar_um_relatorio:
    "e na sequência preencha todos os campos para exportar um relatório",
  Exportar_relatorio: "Exportar relatório",
  Cadastro_de_usuarios: "Cadastro de usuários",
  Cadastro_de_revenda: "Cadastro de revenda",
  Comprovacao: "Comprovação",
  Log_de_acessos: "Log de acessos",
  Log_de_registros: "Log de registros",
  Mystery_Shopper: "Mystery Shopper",
  Templates: "Templates",
  Faca_aqui_o_acaompanhamento_dos_chamados_de_fale_conosco:
    "Faça aqui o acompanhamento dos chamados de fale conosco",
  Assunto: "Assunto",
  Motivo: "Motivo",
  Protocolo: "Protocolo",
  Reclamante: "Reclamante",
  Dias_na_fila: "Dias na fila",
  N_de_interacoes: "Nº de interações",
  Finalizadas: "Finalizadas",
  Finalizados: "Finalizados",
  Detalhes_do: "Detalhes do",
  Chamado: "Chamado",
  Historico_de: "Histórico de",
  Interacoes: "Interações",
  Resposta: "Resposta",
  Hora_de_retorno: "Hora de retorno",
  Data_de_retorno: "Data de retorno",
  Anexar_arquivo_maximo_5mb: "Anexar arquivo, máximo (5mb)",
  Encerrar_chamado: "Encerrar chamado",
  Perfil_de_acesso_invalido: "Perfil de acesso inválido",
  Departamento_inválido: "Departamento inválido",
  Cargo_inválido: "Cargo inválido",
  Confirmar_senha: "Confirmar senha",
  Ausencia_Temporaria: "Ausência Temporária",
  Ativar_Ausencia_Temporaria: "Ativar ausência temporária",
  Selecionar_Ausencia_Temporaria: "Selecionar ausência temporária",
  Selecionar_tipo_de_prazo: "Selecionar tipo de prazo",
  Selecione_o_usuario_que_devera_receber_os_processos_durante_o_periodo_informado:
    "Selecione o usuário que deverá receber os processos durante o período informado",
  Durante_o_periodo_informado_o_usuario_selecionado_tera_acesso_a_todos_os_processos_em_seu_nome_As_notificacoes_ficarao_desativadas:
    "Durante o período informado, o usuário selecionado terá acesso a todos os processos em seu nome. As notificações ficarão desativadas.",
  Administrador_cadastrado_com_sucesso: "Administrador cadastrado com Sucesso",
  Administrador_alterado_com_sucesso: "Administrador alterado com Sucesso",
  Banner_cadastrado_com_sucesso: "Banner cadastrado com Sucesso",
  Banner_alterado_com_sucesso: "Banner alterado com Sucesso",
  Tamanho_recomendado_para_banners_e_de_1920px_x_500px:
    "O tamanho recomendado para banners é de 1920px x 500px",
  Cadastrado_com_sucesso: "Cadastrado com sucesso",
  Editado_com_sucesso: "Editado com sucesso",
  Cadastro_alterado_com_sucesso: "Cadastro alterado com sucesso",
  Processo_encaminhado_para_aprovacao_com_sucesso:
    "Processo encaminhado para aprovação com sucesso",
  Aprovado_com_sucesso: "Aprovado com sucesso",
  Alterado_com_sucesso: "Alterado com sucesso",
  Verifique_seu_email: "Verifique o seu e-mail",
  Transferencia_realizada: "Transferência realizada",
  Noticia_cadastrada_com_sucesso: "Notícia cadastrada com sucesso",
  Noticia_alterada_com_sucesso: "Notícia alterada com sucesso",
  Notificacao_alterada_com_sucesso: "Notificação alterada com sucesso",
  Notificacao_cadastrada_com_sucesso: "Notificação cadastrada com sucesso",
  Participante_cadastrado_com_sucesso: "Participante cadastrado com Sucesso",
  Participante_alterado_com_sucesso: "Participante alterado com Sucesso",
  Participante: "Participante",
  Administrador: "Administrador",
  CPF_nao_encontrado: "CPF não encontrado",
  Politica_de_Accrual_cadastrada_com_sucesso:
    "Política de Accrual cadastrada com sucesso",
  Politica_de_Accrual_publicada_com_sucesso:
    "Política de Accrual publicada com sucesso",
  Todas_datas_de_prazo_foram_alteradas_com_sucesso:
    "Todas datas de prazo foram alteradas com sucesso",
  Politica_de_Accrual_alterada_com_sucesso:
    "Política de Accrual alterada com sucesso",
  Importacao: "Importação",
  Tipo_de_importacao: "Tipo de importação",
  Escolher_arquivo: "Escolher arquivo",
  Importar_arquivo: "Importar arquivo",
  Baixar_modelo: "Baixar modelo",
  Selecione_um_tipo_de_importacao: "Selecione um tipo de importação",
  Para_fazer_o_upload_em_massa_do_seu_estoque_siga_as_orientacoes_abaixo:
    "Para fazer o upload em massa do seu estoque, siga as orientações abaixo",
  Clique_em_Baixar_Modelo_para_fazer_o_download_da_planilha_de_importacao:
    "Clique em 'Baixar Modelo' para fazer o download da planilha de importação",
  A_planilha_deve_estar_no_formato_xlsx:
    "A planilha deve estar no formato .xlsx",
  O_arquivo_nao_deve_conter_celulas_mescladas:
    "O arquivo não deve conter células mescladas",
  A_primeira_linha_deve_conter_o_cabecalho_das_colunas:
    "A primeira linha deve conter o cabeçalho das colunas",
  Deve_haver_somente_uma_aba_no_arquivo:
    "Deve haver somente uma aba no arquivo",
  Apos_a_importacao_veja_o_resultado_de_cada_registro_clicando_nos_numeros_processados:
    "Após a importação, veja o resultado de cada registro clicando nos   números processados",
  No_caso_de_erro_no_upload_sera_gerada_uma_planilha_com_o_descritivo_do_erro_de_leitura_na_ultima_coluna_Favor_consultar_ajustar_e_carregar_novamente:
    "No caso de erro no upload, será gerada uma planilha com o descritivo do erro de leitura na última coluna. Favor consultar, ajustar e carregar novamente.",
  Log_de: "Log de",
  Tipo: "Tipo",
  Arquivo: "Arquivo",
  Total: "Total",
  Ok: "Ok",
  Duplicado: "Duplicado",
  Erro: "Erro",
  Vendas_de_total: "Vendas de total",
  Log_de_duplicados: "Log de duplicados",
  Log_de_erros: "Log de erros",
  Log_de_sucesso: "Log de sucesso",
  Orientacoes: "Orientações",
  Alterar_data: "Alterar data",
  Voce_nao_tem_permissao_para_acessar_esta_pagina:
    "Você não tem permissão para acessar esta página",
  Voce_nao_tem_permissao: "Você não tem permissão",
  Gestao_de_processos: "Gestão de processos",
  Configure_e_gerencie_aqui_os_workflows_de_aprovacao:
    "Configure e gerencie aqui os workflows de aprovação",
  Adicionar_processo_de_aprovacao: "Adicionar processo de aprovação",
  Data_e_Hora: "Data e Hora",
  Configuracao_de_Etapas: "Configuração de Etapas",
  De_Aprovacao: "de aprovação",
  Novo_Processo: "Novo Processo",
  Nome_do_Processo: "Nome do Processo",
  Aprovacao_de_verba: "Aprovação de verba",
  Consultor_Supervisor: "Consultor/Supervisor",
  Presidente: "Presidente",
  Extra: "Extra",
  Tetos_de_aprovacao: "Tetos de aprovação",
  Diretor_Maior_ou_Igual: "DIRETOR (Maior ou igual)",
  Presidente_Maior_ou_Igual: "PRESIDENTE (Maior ou igual)",
  Marketing: "Marketing",
  Gerente: "Gerente",
  Diretor: "Diretor",
  Lista_vazia: "Lista vazia",
  Usuarios_selecionados: "Usuários selecionados",
  SLA_da_etapa_dias: "SLA da etapa (dias)",
  Tipo_de_Acao_Obrigatoria: "Tipo de Ação Obrigatória",
  midia: "Midia",
  Tipo_de_midia_Obrigatoria: "Tipo de midia Obrigatória",
  Tipo_de_midia: "Tipo de midia",
  Tipo_de: "Tipo de",
  Janeiro: "Janeiro",
  Fevereiro: "Fevereiro",
  Marco: "Março",
  Abril: "Abril",
  Maio: "Maio",
  Junho: "Junho",
  Julho: "Julho",
  Agosto: "Agosto",
  Setembro: "Setembro",
  Outubro: "Outubro",
  Novembro: "Novembro",
  Dezembro: "Dezembro",
  Numero_de_processos: "Nº de processos",
  Bem_vindo_ao_portal_da_revenda: "Bem-vindo(a) ao portal da revenda",
  Ver_mais_Noticias: "Ver mais Notícias",
  Marcar_como_lido: "Marcar como lido",
  Ver_mais: "VER MAIS",
  Comprovacao_de_despesas: "Comprovação de despesas",
  Solicitacao_de_verba: "Solicitação de verba",
  Acompanhe_o_andamento_das_suas_comprovacoes:
    "Acompanhe o andamento de suas comprovações",
  Acompanhe_o_andamento_as_suas_solicitacoes:
    "Acompanhe o andamento de suas solicitações",
  Total_Creditado: "Total Creditado",
  Total_Pendente: "Total Pendente",
  Nova_Solicitacao: "Nova Solicitação",
  Rascunho: "Rascunho",
  Conteudo_a_ser_veiculado: "Conteúdo a ser veiculado",
  Orcamento: "Orçamento",
  Outros: "Outros",
  Documentação_solicitada: "Documentação solicitada",
  Documentos_especificos: "Documentos específicos",
  Nota_Fiscal: "Nota Fiscal",
  Comprovante_de_Midia: "Comprovante de Mídia",
  Comprovacao_de: "Comprovação de",
  Atencao_Sera_permitido_apenas_1_anexo_por_documentacao_solicitada_Caso_o_volume_de_arquivos_seja_superior_salve_em_zip:
    "Atenção! Será permitido apenas 1 anexo por documentação solicitada.Caso o volume de arquivos seja superior, salve em .zip",
  Para_uma_melhor_experiencia_nao_realize_upload_de_arquivos_superiores_a_5MB:
    "Para uma melhor experiência, não realize upload de arquivos superiores a 5MB",
  Salvar_como_rascunho: "Salvar como rascunho",
  Enviar_para_aprovacao: "Enviar para aprovação",
  Anexar: "Anexar",
  Cadastre_se: "Cadastre-se",
  Vamos_la: "Vamos lá?",
  Comece_Informando_o_CNPJ_da_sua_Revenda:
    "Comece Informando o CNPJ da sua Revenda",
  Prosseguir: "Prosseguir",
  Precisamos_agora_que_informe_o_seu_email_ok:
    "Precisamos agora que informe o seu e-mail, ok?",
  Informe_seu_email: "Informe seu e-mail",
  Muito_obrigado: "Muito obrigado!",
  Agora_precisamos_saber_um_pouco_mais_sobre_voce:
    "Agora precisamos saber um pouco mais sobre você!",
  Nome_Completo: "Nome Completo",
  Telefone_invalido: "Telefone inválido",
  E_pra_terminar: "E pra terminar :)",
  Vamos_cadastrar_sua_senha: "Vamos cadastrar sua senha:",
  Usuario_Login: "Usuário (login)",
  Parabens: "Parabéns!",
  Sua_conta_foi_criada_com_sucesso: "A sua conta foi criada com sucesso.",
  Voce_podera_alterar_seus_dados_aqualquer_momento:
    "Você poderá alterar seus dados a qualquer momento em ",
  Meu_Cadastro: "Meu Cadastro.",
  Ir_para_o_portal: "Ir para o portal",
  Voce_entrara_no_portal_em: "Você entrará no portal em:",
  Codigo: "Código",
  Insercao_da_Acao: "Inserção da Ação\n(Revendedor)",
  Aprovacao_Consultor: "Aprovação\nConsultor",
  Gerente_Regional: "Gerente\n Regional",
  Credito_liberado: "Crédito\nliberado",
  Insercao_da_Acao_Revendedor: "Inserção da Ação\n(Revendedor)",
  Aprovacao_Continental: "Aprovação\n Continental",
  Aprovado_excucao: "Aprovado para\nExcução",
  Comprovacao_da_despesa_revendedor: "Comprovação da Despesa\n(Revendedor)",
  Pagamento_do_Reembolso: "Pagamento do\nReembolso",
  Consulte_as_politicas_vigentes: "Consulte aqui as políticas vigentes",
  Politica_vigente_para_verbas_inseridas_no_portal_no_periodo_de:
    "Política vigente para verbas inseridas no portal no período de:",
  Ate: "até",
  Abrir_um_novo_chamado: "Abrir um novo chamado",
  Codigo_do_Cliente: "Código do cliente",
  Para_facilitar_suas_solicitações_e_consultas_selecione_as_filiais_para_as_quais_pretende_realizar_ações:
    "Para facilitar suas solicitações e consultas, selecione as filiais para as quais pretende realizar ações:",
  O_CNPJ_informado_faz_parte_de_um_grupo_com_outros_CNPJs_vinculados:
    "O CNPJ informado faz parte de um grupo com outros CNPJs vinculados",
  Deseja_adicionar_todas_as_filiais_do_grupo_para_este_usuario:
    "Deseja adicionar todas as filiais do grupo para este usuário?",
  Relatorio_de_comprovacao: "Relatório de comprovação",
  Relatorio_de_aprovacao: "Relatório de aprovação",
  Relatorio_de_fale_conosco: "Relatório de fale conosco",
  Relatorios_de_financas: "Relatórios de finanças",
  Relatorio_de_usuarios: "Relatório de usuários",
  Relatorio_de_revendas: "Relatório de revendas",
  Ausencia_criada_com_sucesso: "Ausência criada com sucesso!",
  Ausencia_encerrada_com_sucesso: "Ausência encerrada com sucesso!",
  Dashboard: "Dashboard",
  Log: "Log",
  Nao_ha_notificacoes: "Não há notificações",
  Perfil: "Perfil",
  Galeria_de_Midia_M: "MEDIA LIBRARY",
  Midia: "Mídia",
  Center: "Center",
  Atividades_Recentes: "Atividades recentes",
  Favoritos: "Favoritos",
  Lixeira: "Lixeira",
  Itens_Cometilhados: "Itens Compartilhados",
  Links: "Links",
  Pastas_Compartilhadas: "Pastas Compartilhadas",
  Adicionar_pasta: "Adicionar pasta",
  Fazer_upload: "Fazer upload",
  Compartilhar_Pasta: "Compartilhar Pasta",
  Criar_novo_link: "Criar novo link",
  Nova_pasta_compartilhada: "Nova pasta compartilhada",
  Visualizacao: "Visualização",
  Selecionar_todos: "Selecionar todos",
  Efetuar_download: "Efetuar download",
  Copiar: "Copiar",
  Mover: "Mover",
  Classificacao: "Classificação",
  Tamanho: "Tamanho",
  Tipo: "Tipo",
  Data_do_descarte: "Data do descarte",
  Usuario_que_inativou: "Usuário que inativou",
  Classificacao_alterada_com_sucesso: "Classificação alterada com sucesso!",
  Autor: "Autor",
  Data_de_inclusao: "Data de inclusão",
  Dono: "Dono",
  Acesso: "Acesso",
  Compartilhado_em: "Compartilhado em",
  Data_do_compartilhamento: "Data do compartilhamento",
  Compartilhado_com: "Compartilhado com",
  Data_Fim: "Data Fim",
  Mostrando: "Mostrando",
  de: "de",
  ate: "até",
  registros: "registros",
  Abrir: "Abrir",
  Info: "Info",
  Remover_favorito: "Remover favorito",
  Fazer_download: "Fazer download",
  Gerenciar_link: "Gerenciar link",
  Obter_link: "Obter link",
  Remover_link: "Remover link",
  Renomear: "Renomear",
  Remover: "Remover",
  Compartilhar: "Compartilhar",
  Nova_pasta: "Nova pasta",
  Publicar_para_mim: "Publicar para mim",
  Publicar_para_todos: "Publicar para todos",
  Nome_da_pasta: "Nome da pasta",
  Cancelar: "Cancelar",
  Pesquisar_pasta: "Pesquisar pasta",
  Pesquisar_arquivo: "Pesquisar arquivo",
  Upload_em_andamento: "Upload em andamento",
  Finalizando_o_upload: "Finalizando o upload",
  Destino: "Destino",
  Nuvem_de_arquivos: "Nuvem de arquivos",
  Arquivos_Importados: "Arquivos Importados",
  Identificamos_arquivos_com_mesmo_nome_na_pasta_de_destino:
    "Identificamos arquivo(s) com mesmo nome na pasta de destino.",
  Substituir: "Substituir",
  Upload_finalizado_com_sucesso: "Upload finalizado com sucesso!",
  Tamanho_total: "Tamanho total",
  Contem: "Contém",
  Arquivos: "Arquivos",
  Data_de_criacao: "Data de criação",
  Permissoes: "Permissões",
  Data_de_validade: "Data de validade",
  Indefinida: "Indefinida",
  Senha_de_acesso: "Senha de acesso",
  Definir_data_de_validade: "Definir data de validade",
  Definir_uma_senha: "Definir uma senha",
  Pastas: "Pastas",
  Usuarios_com_acesso: "Usuários com acesso",
  Adicionar_usuarios: "Adicionar usuários",
  Deixar_de_compartilhar: "Deixar de compartilhar",
  Contatos: "Contatos",
  Pesquisar: "Pesquisar",
  Pasta_compartilhada_com_sucesso: "Pasta compartilhada com sucesso!",
  Arquivo_compartilhado_com_sucesso: "Arquivo compartilhado com sucesso!",
  Compartilhamento_removido_com_sucesso:
    "Compartilhamento removido com sucesso!",
  Editar_pasta: "Editar pasta",
  Aplicar_alterações_em_sub_pastas_e_arquivos:
    "Aplicar alterações em sub-pastas e arquivos!",
  Pasta_alterada_com_sucesso: "Pasta alterada com sucesso!",
  Preencha_o_nome_da_pasta: "Preencha o nome da pasta",
  Renomear_Arquivo: "Renomear Arquivo",
  Renomear_Pasta: "Renomear Pasta",
  Novo_nome_do_arquivo: "Novo nome do arquivo",
  Novo_nome_da_pasta: "Novo nome da pasta",
  Nova_pasta: "Nova pasta",
  Movendo: "Movendo",
  Itens_selecionados: "Itens selecionados",
  Minhas_pastas: "Minhas pastas",
  Pasta_criada_com_sucesso: "Pasta criada com sucesso!",
  Pasta_removida_com_sucesso: "Pasta removida com sucesso!",
  Arquivo_removido_com_sucesso: "Arquivo removido com sucesso!",
  Notificacao_deletada_com_sucesso: "Notificação deletada!",
  Copiado_com_sucesso: "Copiado com sucesso!",
  Informar_a_data_inicial: "Informar a data inícial",
  Informar_a_data_final: "Informar a data final",
  A_data_inicial_nao_pode_ser_maior_que_a_data_final:
    "A data inícial não pode ser maior que a data final",
  Informar_a_data_inicial: "Informar a data inícial",
  Preencha_o_nome_do_arquivo: "Preencha o nome do arquivo",
  Arquivo_alterado_com_sucesso: "Arquivo alterado com sucesso!",
  Preencha_o_campo_da_data_de_validade: "Preencha o campo da data de validade",
  Data_de_validade_atualizada_com_sucesso:
    "Data de validade atualizada com sucesso!",
  Preencha_o_campo_de_senha: "Preencha o campo de senha",
  Senha_atualizada_com_sucesso: "Senha atualizada com sucesso!",
  Link_copiado_com_sucesso: "Link copiado com sucesso!",
  Movido_com_sucesso: "Movido com sucesso!",
  Arquivo_renomeado_com_sucesso: "Arquivo renomeado com sucesso!",
  Pasta_renomeada_com_sucesso: "Pasta renomeada com sucesso!",
  Upload_cancelado_com_sucesso: "Upload cancelado com sucesso!",
  Item_removido_com_sucesso: "Item(s) removido(s) com sucesso!",
  Ocorreu_falha_no_processamento: "Ocorreu falha no processamento!",
  Link_removido_com_sucesso: "Link removido com sucesso!",
  Restaurado_com_sucesso: "Restaurado com sucesso!",
  Lixeira_esvaziada_com_sucesso: "Lixeira esvaziada com sucesso!",
  Pasta_criada_com_sucesso: "Pasta criada com sucesso!",
  Links_atualizados_com_sucesso: "Links atualizados com sucesso!",
  Notificacao_deletada_com_sucesso: "Notificação deletada com sucesso!",
  Usuario_atualizado_com_sucesso: "Usuário atualizado com sucesso!",
  Extensao_nao_tem_suporte_a_visualizacao:
    "Extensão não tem suporte a visualização",
  Selecione_uma_pasta: "Selecione uma pasta",
  Selecionar: "Selecionar",
  Preencha_a_senha_para_acessar_o_conteudo_do_link:
    "Preencha a senha para acessar o conteúdo do link",
  Senha_incorreta: "Senha incorreta",
  Selecione_pasta_ou_arquivo_para_download:
    "Selecione pasta ou arquivo para download",
  Selecione_pasta_ou_arquivo_para_mover:
    "Selecione pasta ou arquivo para mover",
  Selecione_pasta_ou_arquivo_para_copiar:
    "Selecione pasta ou arquivo para copiar",
  Selecione_pasta_ou_arquivo_para_remover:
    "Selecione pasta ou arquivo para remover",
  Data_do_Descarte: "Data do Descarte",
  Restaurar: "Restaurar",
  Atividades_Recentes: "Atividades Recentes",
  Ultimas_Notificacoes: "ÚLTIMAS NOTIFICAÇÕES",
  Deseja_realmente_excluir_a_notificacao:
    "Deseja realmente excluir a notificação?",
  Dados_Cadastrais: "Dados Cadastrais",
  Permissoes_de_Visualizacao: "Permissões de Visualização",
  Aplicar: "Aplicar",
  Ver_Perfil: "Ver Perfil",
  Confirmar_alteracao: "Confirmar alteração",
  Permissoes_Adicionadas: "Permissões Adicionadas",
  Adicionar_Permissoes: "Adicionar Permissões",
  Nova_Notificacao: "Nova Notificação",
  Cadastradas: "Cadastradas",
  Armazenamento: "Armazenamento",
  Utilizacao: "Utilização",
  Nivel_de_acesso: "Nível de Acesso",
  Somente_imagens_nos_formatos_sao_aceitas:
    "Serão aceitas somente imagens nos formatos:",
  Png_Jgp_E_Jpeg: "PNG, JPG E JPEG. ",
  As_dimensoes_devem_ser_1920_x_324: "As dimensões recomendadas são: 1000 x 200 px. ",
  Inativar_Banner: "INATIVAR BANNER",
  Ativar_Banner: "ATIVAR BANNER",
  Ordem: "Ordem",
  Insira_a_ordem: "Insira a ordem",
  Link: "Link",
  Adicionar_Destinatario: "Adicionar Destinatário",
  Excluir_Destinatario: "Excluir Destinatário",
  Notificacao: "Notificação",
  Informacoes: "Informações",
  Modulos: "Módulos",
  Hora: "Hora",
  Data: "Data",
  Informe_o_titulo: "Informe o título",
  Informe_o_subtitulo: "Informe o  subtítulo",
  Informe_o_usuario: "Informe o usuário",
  Portal_do_Varejo: "Portal do Varejo",
  Agendar_notificacao: "Agendar notificação",
  Insira_o_titulo: "Insira o título",
  Insira_o_subtitulo: "Insira o  subtítulo",
  Insira_o_link: "Insira o link",
  Usuarios_com_esta_permissao: "Usuários com esta permissão",
  Breve_descricao: "Breve descrição",
  Escreva_aqui_uma_breve_descricao_da_permissao:
    "Escreva aqui uma breve descrição da permissão",
  Pastas_com_esta_permissao: "Pastas com esta permissão",
  Excluir_pasta: "Excluir pasta",
  Incluir_subpastas_e_arquivos: "Incluir sub-pastas e arquivos",
  Ver_permissao: "Ver permissão",
  Log_de_movimentacao: "Log de movimentação",
  Data_alteracao: "Data alteração",
  Gerar_Relatorio: "Gerar Relatório",
  Imagem_Tela_de_Login: "Imagem Tela de Login",
  Dimensoes_recomendadas_para_imagem_login: "As dimensões recomendadas são flexíveis, mas recomenda-se imagens de alta qualidade.",
};

